export function findAlteredRegion(data, initialData, fieldList) {
  data.forEach(region => {
    const foundRegion = initialData.find(initialRegion => initialRegion.id === region.id);
    /**
     * If any of the given fields for a region are
     * altered we mark the region with the altered key
     */
    fieldList?.main?.forEach(key => {
      if (region[key] !== foundRegion[key]) {
        return region['altered'] = true;
      }
    });
    /**
     * If the region has not been marked as altered
     * and any of the given fields under the kumba_sap_information data
     * are altered we mark the region with the altered key
     */
    !region?.altered && fieldList?.kumba?.forEach(key => {
      if (region?.kumba_sap_information?.data[key] !== foundRegion?.kumba_sap_information?.data[key]) {
        return region['altered'] = true;
      }
    });
  });
  return data;
}

export function clearError(data) {
  data.forEach(region => region?.errors && (region.errors = null));
  return data;
}

export function filterAlteredRegion(data) {
  return data?.filter(region => region?.altered || region?.isNew || region?._destroy);
}
